module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4df6f102bcf57df426152ea842ca629d.png";